"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../services");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Paragraph = _styledComponents.default.p`
  font-weight: ${props => props.weight};
  margin-bottom: ${props => props.bottom};
  line-height: ${props => {
  var _props$lineHeight;
  return (_props$lineHeight = props.lineHeight) !== null && _props$lineHeight !== void 0 ? _props$lineHeight : '10px';
}};
  word-break: normal;
  white-space: normal;
  font-size: ${prop => {
  var _prop$fontSize;
  return (_prop$fontSize = prop.fontSize) !== null && _prop$fontSize !== void 0 ? _prop$fontSize : 18;
}}px;
`;
const ErrorBodyContainer = _styledComponents.default.div`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  & > div {
    width: 100%;
  }
  & div[class*='StateNotificationstyle__IconWrapper'] {
    align-items: start;
    padding: 20px 15px 15px;
  }
`;
const GermanyErrorBody = () => {
  return /*#__PURE__*/_react.default.createElement(ErrorBodyContainer, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, {
    col: 12
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.StateNotification, {
    state: "error"
  }, /*#__PURE__*/_react.default.createElement(Paragraph, {
    weight: "700",
    bottom: "2%",
    lineHeight: "25px",
    fontSize: 20
  }, _services.Services.locale.localeString('PageErrorMessage.ErrorMessageHeading')), /*#__PURE__*/_react.default.createElement(Paragraph, {
    lineHeight: "27px",
    bottom: "0%"
  }, _services.Services.locale.localeString('PageErrorMessage.ErrorMessageBodyPart1')), /*#__PURE__*/_react.default.createElement(Paragraph, {
    lineHeight: "27px",
    bottom: "0%"
  }, _services.Services.locale.localeString('PageErrorMessage.ErrorMessageBodyPart2')), /*#__PURE__*/_react.default.createElement(Paragraph, {
    lineHeight: "27px",
    bottom: "0%"
  }, _services.Services.locale.localeString('PageErrorMessage.ErrorMessageBodyPart3')), /*#__PURE__*/_react.default.createElement(Paragraph, {
    lineHeight: "27px",
    bottom: "0%"
  }, _services.Services.locale.localeString('PageErrorMessage.ErrorMessageBodyPart4'))))));
};
var _default = GermanyErrorBody;
exports.default = _default;